import React, { FC } from 'react';
import ChipWithTooltip from '@components/ChipWithTooltip';
import IdTitle from '@components/EntityDrawers/components/ReferencesInputsGroup/components/IdTitle';
import IgBadge from '@components/EntityDrawers/components/ReferencesInputsGroup/components/IgBadge';
import { ImplementationGroup } from '@constants/entities/project';
import { useTruncatedWithCount } from '@hooks/useTruncatedWithCount';
import { ChipProps, Stack, Typography } from '@mui/material';

type Props = {
  label: string;
  tier?: ImplementationGroup | null;
  chipProps?: ChipProps;
};

const CHIP_MAX_WIDTH = 280;

const CisReferenceChip: FC<Props> = ({ label, tier, chipProps }) => {
  const { textRef, isTruncated } = useTruncatedWithCount<HTMLElement>(label);
  const [id, title] = label?.split(':') ?? ['', ''];

  return (
    <ChipWithTooltip
      label={label}
      tooltip={{
        title: <IdTitle id={id} title={title} />,
        disableHoverListener: !isTruncated,
      }}
      chip={{
        ...chipProps,
        label: (
          <Stack
            direction="row"
            alignItems="center"
            gap={2}
            sx={{ minWidth: 0 }}
          >
            <Typography
              ref={textRef}
              variant="body2"
              color="inherit"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
              }}
            >
              {label}
            </Typography>

            {tier && <IgBadge tier={tier} />}
          </Stack>
        ),
        sx: {
          cursor: 'pointer',
          maxWidth: CHIP_MAX_WIDTH,

          '& .MuiChip-label': {
            overflow: 'hidden',
            minWidth: 0,
          },
        },
      }}
    />
  );
};

export default CisReferenceChip;
